import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { modal } from "../../../../util";
import apiHelper, { api } from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { toast } from "react-toastify";

import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import DragAndDropTable from "../../../common/DragAndDropTable";

function ImportButton(props) {
  const { disabled, onChangeHandler } = props;
  const ref = React.useRef();

  const reset = () => {
    console.log("here");
    ref.current.value = "";
  };

  return (
    <label htmlFor="import-data">
      <input
        id="import-data"
        type="file"
        hidden
        onChange={(event) => {
          onChangeHandler(event, reset);
        }}
        ref={ref}
      />
      <Button
        variant="contained"
        component="span"
        color="primary"
        disabled={disabled}
      >
        Import from .csv
      </Button>
    </label>
  );
}

export default function ProgrammeListingPage({ disabled, ...props }) {
  const [rows, setRows] = React.useState([]);
  const [searchString, setSearchString] = React.useState("");
  const [globalFilter, setGlobalFilter] = React.useState("");

  const { setLoading } = useLoading();

  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = React.useState(0);

  const columns = React.useMemo(
    () => [
      {
        Header: "Programme Title (English)",
        accessor: "titleEn",
        Cell: ({ row, cell }) => {
          return (
            <Link
              to={`/cinefan/programmes/edit/${row.original.id}`}
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
            >
              {row.original.titleEn}
            </Link>
          );
        },
      },
      {
        Header: "Programme Title (Chinese)",
        accessor: "titleTc",
        Cell: ({ row, cell }) => {
          return (
            <Link
              to={`/cinefan/programmes/edit/${row.original.id}`}
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
            >
              {row.original.titleTc}
            </Link>
          );
        },
      },
      {
        Header: "Parent Period",
        accessor: "parentPeriod",
        disableGlobalFilter: true,
      },
      {
        Header: "Period",
        accessor: "period",
        disableGlobalFilter: true,
      },
      {
        Header: "Status",
        accessor: "status",
        disableGlobalFilter: true,
      },
    ],
    []
  );

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setPageIndex(0);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const getProgrammes = React.useCallback(
    async () => {
      setLoading(true);
      try {
        const result = await apiHelper.cinefan.getProgrammes(
          pageIndex,
          (pageIndex + 1) * pageSize,
          pageSize,
          null,
          globalFilter
        );
        setRows(result.data.content.filter((x) => x));
        setTotalElements(result.data.totalElements);
        setTotalPages(result.data.totalPages);
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    },
    [pageIndex, pageSize, globalFilter]
  );

  React.useEffect(() => {
    if (pageSize) getProgrammes();
  }, [getProgrammes, pageIndex, pageSize, globalFilter]);

  const deleteProgramme = async (id) => {
    const decision = await modal.fire({
      title: "Delete Programme",
      text: "Are you sure to delete this programme?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        const result = await apiHelper.cinefan.deleteProgrammeById(id);
        if (result.data.code === 0) {
          toast.dark("Programme deleted.");
          getProgrammes();
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const saveOrdering = async () => {
    try {
      const seqArray = rows.map((item) => item.seq);
      seqArray.sort((a, b) => b - a);

      const seqData = {};
      rows.forEach((e, i) => {
          seqData[e.id] = seqArray[i]; 
      });

      const result = await apiHelper.cinefan.updateProgrammeSeq(seqData); 
      if (result.data.code === 0) {
        toast.dark("Your changes are saved.");
        // refetch current page banners
        getProgrammes();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleFileUpload = async (event, reset) => {
    event.preventDefault();
    const fd = new FormData();
    fd.append("file", event.target.files[0]);
    try {
      const result = await api.post("/cinefan/admin/programme/import", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (0 === result?.data?.code) {
        toast.dark("Successfully imported.");
        getProgrammes();
      }
    } catch (err) {
      console.log(err);
    } finally {
      reset();
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Programmes & Periods
      </Typography>
      <Grid container justify="space-between">
        {/* <Grid container item xs={6} md={6}> */}
        <Grid container item xs={3} md={3}>
          {/* <Grid item xs={6}> */}
          {/* <Box width="100%" component="span" display="flex">
            <Box width="100%">
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  Bulk Actions
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={actionType}
                  onChange={handleSelectChange}
                  label="Bulk Actions"
                  disabled={disabled}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"DELETE"}>Delete</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex">
              <Button
                variant="outlined"
                color="primary"
                onClick={handleBulkAction}
                disabled={disabled}
              >
                Apply
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={()=>setIsSaveOrdering(true)}
                disabled={disabled}
              >
                Save Change
              </Button>
            </Box>
          </Box> */}
          {/* </Grid> */}

          {/* Uncomment these in case the date filtering function is needed later */}

          {/* <Grid item xs={6}>
            <Box width="100%" component="span" display="flex">
              <Box width="100%">
                <FormControl fullWidth margin="dense" variant="outlined">
                  <InputLabel id="demo-simple-select-outlined-label">
                    All dates
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={age}
                    onChange={handleChange}
                    label="All dates"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"delete"}>Delete</MenuItem>
                    <MenuItem value={"delete"}>Delete</MenuItem>
                    <MenuItem value={"delete"}>Delete</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex">
                <Button variant="outlined" color="primary">
                  Filter
                </Button>
              </Box>
            </Box>
          </Grid> */}
        </Grid>
        {/* <Grid container item xs={12} md={6}> */}
        <Grid container item xs={9} md={6}>
          <Box
            width="100%"
            component="span"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box display="flex">
              <ImportButton
                onChangeHandler={handleFileUpload}
                disabled={disabled}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getProgrammes}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.cinefan.deleteProgrammeById(id)))}
            subject="Movie"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={deleteProgramme}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
            editPath={`${props.match.url}/edit`}
            addBtnLink={`${props.match.url}/create`}
            addBtnName="Add Programme"
            isUnpaged={true}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
